"use client";

import { z } from "zod";

import { Button } from "@/common/components-2/button";
import { MigrationLink } from "@/common/components-2/migration-link";
import { SanitizedContent } from "@/common/components-2/sanitized-content";
import { Section } from "@/common/components-2/section";
import { CmsSectionHeading } from "@/common/components-2/section-heading/cms-section-heading";
import type { HranoPage } from "@/payload-types";
import { EmitErrorReport } from "@/services/cms/components/emit-error-report";
import { CmsIconItem } from "../../../_components/cms-icon-item";

const howSectionSchema = z.object({
  heading: z.string(),
  description: z.string(),
  items: z.array(
    z.object({
      icon: z.string(),
      title: z.string(),
      description: z.string(),
    }),
  ),
  button: z.object({
    label: z.string(),
    url: z.string(),
  }),
});

export function HowSection(props: HranoPage["hs"]) {
  let propsData: z.infer<typeof howSectionSchema>;

  try {
    propsData = howSectionSchema.parse(props);
  } catch (ex) {
    return <EmitErrorReport error={JSON.stringify(ex)} name="How section" />;
  }

  const { heading, description, items, button } = propsData;

  return (
    <Section classes={{ section: "py-10 md:py-14 lg:py-20" }}>
      <CmsSectionHeading heading={heading} />
      <SanitizedContent as="div" content={description} className="text-center text-xl" />
      <ul className="mt-12 grid grid-cols-1 gap-14 md:mt-14 md:grid-cols-3 md:gap-y-20">
        {items.map((item) => (
          <CmsIconItem key={item.title} icon={item.icon} title={item.title} description={item.description} />
        ))}
      </ul>
      <Button asChild size="lg" className="mx-auto mt-14 max-md:w-full md:mt-16">
        <MigrationLink href={button.url}>{button.label}</MigrationLink>
      </Button>
    </Section>
  );
}
